import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-easebuzz-pay',
  templateUrl: './easebuzz-pay.component.html',
  styleUrls: ['./easebuzz-pay.component.scss']
})
export class EasebuzzPayComponent implements OnInit {
  PayDetails: any;

  constructor(private elRef: ElementRef,
    public router: Router,
    public umsService: UmsService,) { }

  ngOnInit(): void {
    this.PayDetails = this.umsService.getpayDetails();
    this.payNow(this.PayDetails)
  }

  payNow(data) {
    const paymentDetails = {
      "amount": data.paydata['PaidAmount'],
      "StuId": data.paydata['StuId'],
      "FeeTemplateCode": data.paydata['FeeTemplateCode'],
      "FeeType": data.paydata['FeeType'],
      "SnNo": data.paydata['SnNo'],
      "firstname": 'vishnu',
      "email": "jeeevishnu@gmail.com",
      "phone": "8296270993"
    }
    this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
      window.location.href = response.redirectUrl;
    });
  }


}
